import CustomAccording from "../../../customs/according"
import LinkSidebar from "../../../links/link_sidebar"

const SidebarSuperAdmin = () => {
    return (
        <>
            <LinkSidebar link="/dashboard" name="Dashboard" />
            <LinkSidebar link="/dashboard/user" name="Pengguna" />
            <LinkSidebar link="/dashboard/unit" name="Unit / Kavling" />
            <LinkSidebar link="/dashboard/selling" name="Penjualan" />
            <LinkSidebar link="/dashboard/consument" name="Konsumen" />
            <CustomAccording name="Logistik" link="/dashboard/logistic" height="">
                <LinkSidebar link="/dashboard/logistic/suplier" name="Data Suplier" />
                <LinkSidebar link="/dashboard/logistic/material" name="Monitoring Barang" />
                <LinkSidebar link="/dashboard/logistic/procurement" name="Pengadaan Barang" />
                <LinkSidebar link="/dashboard/logistic/used-material" name="Penggunaan Barang" />
            </CustomAccording>
            <LinkSidebar link="/dashboard/crediture" name="Debitur / Kreditur" />
            <LinkSidebar link="/dashboard/financial" name="Keuangan" />
            <CustomAccording name="Konten" link="/dashboard/content" height="">
                <LinkSidebar link="/dashboard/content/galery" name="Galery" />
                <LinkSidebar link="/dashboard/content/advantage" name="Keunggulan" />
                <LinkSidebar link="/dashboard/content/testimony" name="Testimony" />
            </CustomAccording>
            <CustomAccording name="Approved" link="/dashboard/update" height="">
                <LinkSidebar link="/dashboard/update/transaction" name="Transaksi" />
                <LinkSidebar link="/dashboard/update/selling" name="Penjualan" />
                <LinkSidebar link="/dashboard/update/procurement" name="Pengadaan Barang" />
            </CustomAccording>
            {/* <LinkSidebar link="/dashboard/approved" name="Approved" /> */}
        </>
    )
}

export default SidebarSuperAdmin

